import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class AdminLoginPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    // LoginModal.open();
   
    
  }
  oncreate() {
    // this.startCountdown();
    // 延迟显示模态框，避免嵌套的 m.redraw.sync() 调用
    setTimeout(() => {
      app.modal.show(LogInModal);
    }, 0);
  }
  // 组件销毁时清理倒计时
  onremove() {
    
  }

  view() {
    return (
      <div className="MobileRegisterPage">
       11111111
      </div>
    );
  }

  // 验证手机号是否已注册


  // 发送验证码
  async sendCode() {
    const phone = this.phone().trim();
    
    if (!phone) {
      this.errorMessage('请输入手机号');
      return;
    }

    if (!this.isValidPhone(phone)) {
      this.errorMessage('请输入正确的手机号格式');
      return;
    }

    try {
      this.sendCodeDisabled = true;
      this.startCountdown();
      await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/sso/send-code',
        body: {
          phone: phone
        }
      });

      
    } catch (error) {
      console.error('发送验证码失败:', error);
      this.errorMessage('发送验证码失败，请重试');
    }
  }

  // 注册/登录
  async register() {
    const phone = this.phone().trim();
    const code = this.code().trim();
    // const username = this.username().trim();
    // const password = this.password().trim();

    // 基本验证
    if (!phone) {
      this.errorMessage('请输入手机号');
      return;
    }

    if (!this.isValidPhone(phone)) {
      this.errorMessage('请输入正确的手机号格式');
      return;
    }

    if (!code) {
      this.errorMessage('请输入验证码');
      return;
    }

    // if (!this.phoneExists && !username) {
    //   this.errorMessage('请输入用户名');
    //   return;
    // }

    // if (!this.phoneExists && !password) {
    //   this.errorMessage('请输入密码');
    //   return;
    // }

    this.loading = true;
    this.errorMessage('');

    try {
      const requestBody = {
        phone: phone,
        sms_code: code
      };

      // 添加可选参数
      // if (username) {
      //   requestBody.full_name = username;
      // }

      // 获取用户IP地址（如果可用）
      try {
        const ipResponse = await fetch('https://api.ipify.org?format=json');
        const ipData = await ipResponse.json();
        requestBody.user_ip_address = ipData.ip;
      } catch (ipError) {
        console.warn('无法获取IP地址:', ipError);
      }

      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/sso/account-login',
        body: requestBody
      });

      // 处理成功响应
      if (response.data) {
        // 清除错误消息，显示成功消息
        this.errorMessage('');
        this.successMessage('登录成功，正在跳转...');
        
        // 延迟跳转，让用户看到成功消息
        setTimeout(() => {
          // 跳转到首页 - 动态获取根路径，适用于任何环境
          const baseUrl = window.location.origin + window.location.pathname.split('/').slice(0, -1).join('/') + '/';
          window.location.href = baseUrl;
        }, 1000);
      } else {
        this.errorMessage(response.message || '操作失败，请重试');
      }
    } catch (error) {
      console.error('登录失败:', error);
      this.errorMessage('操作失败，请检查验证码是否正确');
    } finally {
      this.loading = false;
    }
  }

  // 验证手机号格式
  isValidPhone(phone) {
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  }

  // 开始倒计时 - 使用setInterval
  startCountdown() {
    // 先停止之前的倒计时
    this.stopCountdown();
    
    this.countdown = 60;
    this.timer = setInterval(() => {
      this.countdown--;
      m.redraw(); // 触发视图更新
      
      if (this.countdown <= 0) {
        this.stopCountdown();
        this.sendCodeDisabled = false;
      }
    }, 1000);
  }
  
  // 停止倒计时
  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;

    }
  }
}
